export const PROJECTS = [
  {
    id: 'knicksiq',
    number: '01',
    title: 'KnicksIQ',
    category: 'Sports intelligence · Full-stack',
    summary: 'Ask a Knicks question. Trace the answer back to the game. A searchable archive of the 2025–26 season, with box scores, play-by-play, and cited answers.',
    metric: '25–26',
    metricLabel: 'season coverage',
    tech: ['React', 'FastAPI', 'PostgreSQL', 'MCP'],
    problem: 'Answering a specific Knicks question meant moving between box scores, play-by-play, and season records. The archive needed to connect an answer to the underlying game, not just return a summary.',
    build: 'I built a React interface and FastAPI service backed by PostgreSQL. Structured play-by-play data supports the question workflow, with citations linking answers to games and an MCP interface for agent access.',
    result: 'KnicksIQ is a public-beta archive of the 2025–26 season. Reviewers can explore the live application, inspect the underlying games, and see citations and data limitations alongside answers. Season coverage describes the archive’s scope, not a performance benchmark.',
    href: 'https://www.knicksiq.win',
    linkLabel: 'Explore KnicksIQ',
    visual: 'court',
    image: '/images/projects/knicksiq-interface.webp',
    imageAlt: 'KnicksIQ season archive: a Madison Square Garden photograph beside the season introduction, above a search form for asking questions about games and players.',
    imageWidth: 1440,
    imageHeight: 1380,
    featured: true,
  },
  {
    id: 'legaldocuman',
    number: '02',
    title: 'LegalDocuMan',
    category: 'Legal operations · AI',
    summary: 'A production document-processing system built around contract end dates and signature detection.',
    metric: '94.9%',
    metricLabel: 'RF-DETR precision',
    tech: ['Python', 'RF-DETR', 'React', 'PostgreSQL'],
    problem: 'Legal teams needed a reliable way to process a large contract drive and organize agreements around their end dates.',
    build: 'A Flask API, React interface, PostgreSQL data layer, Redis workers, OCR extraction, and a fine-tuned RF-DETR model packaged as a multi-container Docker deployment.',
    result: 'The system moved the workflow from an internal script to a production platform with measurable signature-detection performance and recoverable background processing.',
    href: 'https://github.com/Mo-Awadalla/LegalDocuMan',
    linkLabel: 'View repository',
    visual: 'documents',
    image: '/images/projects/legaldocuman-contract.jpg',
    imageAlt: 'LegalDocuMan contract processing: a legal document undergoing signature detection and end-date extraction.',
    imageWidth: 1000,
    imageHeight: 750,
  },
  {
    id: 'autograd',
    number: '03',
    title: 'Autograd Engine',
    category: 'Machine learning · Systems',
    summary: 'A backpropagation engine built from scratch and validated against PyTorch.',
    metric: '32K',
    metricLabel: 'training names',
    tech: ['Python', 'PyTorch', 'Autograd', 'Backprop'],
    problem: 'Using automatic differentiation did not explain what happened inside the graph during forward and backward passes.',
    build: 'A scalar autograd engine with graph construction, gradient propagation, PyTorch validation, and a character-level language model trained on 32,000 names.',
    result: 'The project turned backpropagation from an API abstraction into a system that could be inspected, tested, and used for training.',
    href: 'https://github.com/Mo-Awadalla/autograd',
    linkLabel: 'View engine',
    visual: 'graph',
    image: '/images/projects/autograd-network.jpg',
    imageAlt: 'Autograd Engine computational graph: neural network architecture and backpropagation visualization.',
    imageWidth: 3000,
    imageHeight: 1687,
  },
  {
    id: 'dls',
    number: '04',
    title: 'NYCEM DLS Website',
    category: 'NYC Emergency Management · Web',
    summary: 'A sanitized version of the 2025 NYC Emergency Management Disaster Law Symposium website.',
    metric: '1K+',
    metricLabel: 'registrations',
    tech: ['HTML', 'CSS', 'JavaScript', 'REST APIs'],
    problem: 'NYC Emergency Management needed a reliable registration and attendance workflow for the 2025 Disaster Law Symposium, a hybrid legal conference.',
    build: 'Built a web registration and tracking experience connected to REST APIs. This repository is a sanitized version of the conference site, with sensitive operational details removed.',
    result: 'The system supported more than 1,000 registrations while giving organizers a direct way to track attendance across the 2025 symposium.',
    href: 'https://github.com/Mo-Awadalla/dls-website-sanitized',
    linkLabel: 'View repository',
    visual: 'schedule',
    image: '/images/projects/dls-symposium.jpg',
    imageAlt: 'NYC Emergency Management Disaster Law Symposium: attendees gathered for conference sessions.',
    imageWidth: 1125,
    imageHeight: 750,
  },
];

export const FEATURED_PROJECT = PROJECTS.find((project) => project.featured);
